import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ComingSoonPage from './pages/ComingSoonPage';
import HomePage from './pages/HomePage';
import DealsPage from './pages/DealsPage';
import DealDetailPage from './pages/DealDetailPage';
import BusinessRegisterPage from './pages/BusinessRegisterPage';
import BusinessLoginPage from './pages/BusinessLoginPage';
import BusinessDashboardPage from './pages/BusinessDashboardPage';
import CreateDealPage from './pages/CreateDealPage';
import EditDealPage from './pages/EditDealPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminLoginPage from './pages/AdminLoginPage';
import HowItWorksPage from './pages/HowItWorksPage';
import PricingPage from './pages/PricingPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import UpgradeSuccessPage from './pages/UpgradeSuccessPage';
import DashboardReturnBar from './components/DashboardReturnBar';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import AccessibilityPage from './pages/AccessibilityPage';
import CareersPage from './pages/CareersPage';
import SitemapPage from './pages/SitemapPage';

const IS_COMING_SOON = process.env.REACT_APP_COMING_SOON === 'true';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user || user.type !== 'business') return <Navigate to="/business/login" replace />;
  return children;
};

function PWABanner() {
  const [prompt, setPrompt] = useState(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault(); setPrompt(e);
      if (!localStorage.getItem('hp_pwa_dismissed')) setShow(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);
  const install = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'accepted') setShow(false);
  };
  const dismiss = () => { setShow(false); localStorage.setItem('hp_pwa_dismissed', '1'); };
  if (!show) return null;
  return (
    <div className="pwa-banner">
      <div className="pwa-icon">½p</div>
      <div className="pwa-text">
        <strong>Add halfprice.ca to your phone</strong>
        <span>Get instant deal notifications</span>
      </div>
      <button className="pwa-btn" onClick={install}>Install</button>
      <button className="pwa-close" onClick={dismiss}>×</button>
    </div>
  );
}

export default function App() {
  if (IS_COMING_SOON) return <ComingSoonPage />;

  return (
    <AuthProvider>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/deals" element={<DealsPage />} />
          <Route path="/deals/:id" element={<DealDetailPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/accessibility" element={<AccessibilityPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/sitemap" element={<SitemapPage />} />
          <Route path="/business/register" element={<BusinessRegisterPage />} />
          <Route path="/business/login" element={<BusinessLoginPage />} />
          <Route path="/business/verify/:token" element={<VerifyEmailPage />} />
          <Route path="/upgrade/success" element={<UpgradeSuccessPage />} />
          <Route path="/business/dashboard" element={<ProtectedRoute><BusinessDashboardPage /></ProtectedRoute>} />
          <Route path="/business/deals/new" element={<ProtectedRoute><CreateDealPage /></ProtectedRoute>} />
          <Route path="/business/deals/edit/:id" element={<ProtectedRoute><EditDealPage /></ProtectedRoute>} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
        <PWABanner />
        <DashboardReturnBar />
      </BrowserRouter>
    </AuthProvider>
  );
}
